// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"480":"impressum","792":"main"}[chunkId] + "." + {"480":"1013ac00","792":"22187716"}[chunkId] + ".css";
};